import { OwnerSelectDropdown } from '@repo/ui';
import DataTypeSpecificInput from 'advanced-filters/components/DataTypeSpecificInput';
import SelectWithQuery from 'advanced-filters/components/SelectWithQuery';
import { ALL_DATA_TYPES, type DataTypeType } from 'advanced-filters/data/dataTypes';
import {
  type BaseOptionsType,
  FILTERABLE_ENTITY_TYPES,
  type FilterableEntityTypes,
} from 'advanced-filters/data/options';
import { pendingFilterSelector, selectedBaseConditionDataType } from 'advanced-filters/selectors/filter';
import { modifyPendingFilter } from 'advanced-filters/store/filter';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export default function ConditionValueSelect() {
  const dispatch = useDispatch();
  const {
    conditionKey,
    conditionComparator,
    conditionValue,
  } = useSelector(pendingFilterSelector);
  const comparatorDataType = useSelector(selectedBaseConditionDataType) as DataTypeType;

  const handleChange = useCallback((value: any) => {
    dispatch(modifyPendingFilter({
      conditionValue: value,
      subConditionKey: undefined,
      subConditionComparator: undefined,
      subConditionValue: undefined,
      timeFilter: undefined,
    }));
  }, [dispatch]);

  if (conditionKey?.dataType === ALL_DATA_TYPES.reference_user) {
    return (
      <OwnerSelectDropdown
        multiple
        forceFetch
        value={conditionValue?.value?.map((_value: any) => _value?.value)}
        handleClick={(values = []) => handleChange({
          value: (values as string[]).map((value) => ({
            value,
          })),
        })}
      />
    );
  } else if ((Object.values(FILTERABLE_ENTITY_TYPES) as unknown as string[]).includes(conditionKey?.entityType || '')) {
    return (
      <SelectWithQuery
        context="condition"
        value={conditionValue}
        entity={conditionKey as BaseOptionsType}
        handleChange={handleChange}
        comparisionType={conditionComparator}
      />
    );
  } else {
    return (
      <DataTypeSpecificInput
        entityType={conditionKey?.entityType as FilterableEntityTypes}
        context="condition"
        value={conditionValue}
        inputDataType={comparatorDataType}
        comparisionType={conditionComparator}
        handleChange={handleChange}
      />
    );
  }
}
